import React from 'react';

interface PlusIconProps {
  className?: string;
  verticalClassName?: string;
}

export function PlusIcon({
  className = 'h-5 w-5',
  verticalClassName,
}: PlusIconProps): React.ReactElement {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M4 10h12" />
      <path className={verticalClassName} d="M10 4v12" />
    </svg>
  );
}
